import React, { useState } from "react";

const AllMoreEventsPopupHOC = (Component: any) =>
    function Comp(props: any) {
        const [allMoreEventsPopup, setAllMoreEventsPopup] = useState<boolean>(false);

        const allMoreEventsToggleHandler = () => {
            setAllMoreEventsPopup(!allMoreEventsPopup);
        };

        return (
            <Component
                allMoreEventsPopup={allMoreEventsPopup}
                allMoreEventsToggleHandler={allMoreEventsToggleHandler}
                {...props}
            />
        );
    };

export default AllMoreEventsPopupHOC;